import { useState } from "react";
import { ContentItemsManager } from "./ContentItemsManager";

const TABS = [
  { key: "faq", label: "FAQs" },
  { key: "safety_point", label: "Safety Points" },
  { key: "safety_conduct", label: "Safety Conduct" },
  { key: "about", label: "About Content" },
  { key: "contact", label: "Contact Page" },
  { key: "session_type", label: "Session Types" },
  { key: "announcement", label: "Announcements" },
  { key: "photographer_benefit", label: "Photographer Resources" },
  { key: "legal_doc", label: "Terms & Policies" },
];

export const ContentTab = () => {
  const [active, setActive] = useState("faq");

  return (
    <div data-testid="admin-content-tab">
      <div className="flex flex-wrap gap-2 mb-8">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`content-tab-${t.key}`}
            onClick={() => setActive(t.key)}
            className={`px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wide transition-colors ${
              active === t.key ? "bg-midnight-black text-clean-white" : "bg-warm-white border border-soft-gray text-midnight-black/70 hover:border-stranger-orange"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {active === "faq" && (
        <ContentItemsManager
          section="faq"
          itemLabel="FAQ"
          fields={[
            { key: "title", label: "Question", type: "text" },
            { key: "body", label: "Answer", type: "textarea" },
          ]}
        />
      )}

      {active === "safety_point" && (
        <ContentItemsManager
          section="safety_point"
          itemLabel="Safety Point"
          fields={[
            { key: "icon_key", label: "Icon", type: "icon-select" },
            { key: "title", label: "Title", type: "text" },
            { key: "body", label: "Description", type: "textarea" },
          ]}
        />
      )}

      {active === "safety_conduct" && (
        <ContentItemsManager
          section="text_block"
          itemLabel="Conduct Paragraph"
          forcedValues={{ page: "safety" }}
          filterFn={(i) => i.page === "safety"}
          fields={[{ key: "body", label: "Paragraph", type: "textarea" }]}
        />
      )}

      {active === "about" && (
        <ContentItemsManager
          section="text_block"
          itemLabel="About Paragraph"
          forcedValues={{ page: "about" }}
          filterFn={(i) => i.page === "about"}
          fields={[
            { key: "body", label: "Paragraph", type: "textarea" },
            { key: "is_highlight", label: "Highlight (shown in orange, larger text)", type: "switch" },
          ]}
        />
      )}

      {active === "contact" && (
        <ContentItemsManager
          section="text_block"
          itemLabel="Contact Page Paragraph"
          forcedValues={{ page: "contact" }}
          filterFn={(i) => i.page === "contact"}
          fields={[{ key: "body", label: "Paragraph", type: "textarea" }]}
        />
      )}

      {active === "session_type" && (
        <ContentItemsManager
          section="session_type"
          itemLabel="Session Type"
          fields={[
            { key: "type_key", label: "Type Key (used internally, e.g. romantic)", type: "text" },
            { key: "title", label: "Title", type: "text" },
            { key: "body", label: "Description", type: "textarea" },
            { key: "image_url", label: "Image URL", type: "text" },
          ]}
        />
      )}

      {active === "announcement" && (
        <ContentItemsManager
          section="announcement"
          itemLabel="Announcement"
          fields={[
            { key: "title", label: "Title", type: "text" },
            { key: "body", label: "Message", type: "textarea" },
            { key: "link_url", label: "Link URL (optional)", type: "text" },
            { key: "link_label", label: "Link Label (optional)", type: "text" },
            { key: "expires_at", label: "Expires On (optional)", type: "date" },
            { key: "active", label: "Active (shown to visitors — only one can be active)", type: "switch" },
          ]}
        />
      )}

      {active === "photographer_benefit" && (
        <ContentItemsManager
          section="photographer_benefit"
          itemLabel="Benefit"
          fields={[
            { key: "icon_key", label: "Icon", type: "icon-select" },
            { key: "title", label: "Title", type: "text" },
            { key: "body", label: "Description", type: "textarea" },
          ]}
        />
      )}

      {active === "legal_doc" && (
        <ContentItemsManager
          section="legal_doc"
          itemLabel="Document"
          fields={[
            { key: "slug", label: "URL Slug (e.g. privacy-policy)", type: "text" },
            { key: "title", label: "Title", type: "text" },
            { key: "body", label: "Document Body", type: "textarea" },
          ]}
        />
      )}
    </div>
  );
};
